module.exports = __webpack_public_path__ + "static/media/phone-plus.324104d3.svg";